// import { s8, createDiv, rectangle } from '@topology/core'
import {s8, createDiv} from '@topology/core'
export function IFrame(ctx, node) {
  // 绘制一个底图，类似于占位符
  // rectangle(ctx, node)
  if (!node.data) {
    return
  }
  if (typeof node.data === 'string') { // 解析data属性
    node.data = JSON.parse(node.data)
  }
  if (!node.data.option || !node.data.option.url) { // option/url不允许为空
    return
  }
  if (node.elementId === undefined || node.elementId === null) {
    node.elementId = s8()
  }
  if (!node.elementLoaded) {
    // 创建一个div层
    let nodeDiv = createDiv(node)
    node.extDiv = nodeDiv
    document.body.appendChild(nodeDiv)
    node.addToDiv() // 添加当前节点到div层

    // 创建一个iframe
    let iFrame = document.createElement('iframe')
    iFrame.style.width = '100%'
    iFrame.style.height = '100%'
    iFrame.frameborder = 'no'
    if (node.elementId) {
      iFrame.id = 'iframe' + node.elementId
    }
    iFrame.nodeId = node.id
    iFrame.src = node.data.option.url
    node.extIFrame = iFrame
    nodeDiv.appendChild(iFrame)

    node.extOnDestroy = doNodeDestroy // 关联处理节点销毁函数
    node.elementLoaded = true

    node.elementRendered = false
    // 等待父div先渲染完成调整尺寸
    setTimeout(function () {
      node.extDiv.style.x = node.rect.x + 'px'
      node.extDiv.style.y = node.rect.y + 'px'
      node.extDiv.style.width = node.rect.width + 'px'
      node.extDiv.style.height = node.rect.height + 'px'
    })
  } else {
  }

  if (!node.elementRendered) {
    // 初始化时，等待父div先渲染完成，避免初始图表控件太大。
    setTimeout(function () {
      console.log('node x:' + node.rect.x + ',div x:' + node.extDiv.style.x)
      node.extDiv.style.x = node.rect.x + 'px'
      node.extDiv.style.y = node.rect.y + 'px'
      node.extDiv.style.width = node.rect.width + 'px'
      node.extDiv.style.height = node.rect.height + 'px'
      node.elementRendered = true
      // setTimeout(function () {
      //     var img = new Image()
      //     img.src = flvPlayerObjs[node.id].player.getDataURL({
      //         pixelRatio: 2
      //     })
      //     node.img = img
      // }, 100)
    })
  } else {
  }
}

// 处理节点销毁事件
function doNodeDestroy(node) {
  if (node.extIFrame) {
    node.extIFrame = null
    if (node.extDiv) {
      let iFrame = document.getElementById('iframe' + node.elementId)
      if (iFrame) {
        node.extDiv.removeChild(iFrame)
      }
    }
  }
}

// # sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./src/components/topologyDiagram/iFrame/iFrame/index.js